export const FontActionTypes = {
  INCREASE_FONT: "INCREASE_FONT",
  DECREASE_FONT: "DECREASE_FONT"
};
